module.exports = __webpack_public_path__ + "static/media/5.02596f72.jpeg";